import {css, StyleSheet} from "aphrodite";
import React from 'react';
import GridStyles from "../styles/styles";
import MediaQuery from "../styles/MediaQuery";
import Config from "../config/Config";
import TextDiv from "./containers/TextDiv";
import FeedbackButton from "./FeedbackButton";
import WhatsNewAreaUtils from "./WhatsNewArea/WhatsNewAreaUtils";
import {useSelector} from "react-redux";
import Image from "./containers/Image";

const Switching = ({extraStyle}) => {
    const {isMobile} = useSelector(state => state.styles),
        styles = StyleSheet.create({
            container: {
                ...GridStyles.define("max-content 24px max-content 12px max-content 49px max-content"),
                color: Config.colors.MAIN_TEXT,
                ...MediaQuery.mobile({
                    ...GridStyles.define("max-content 24px max-content 12px max-content 31px max-content")
                })
            },
            title: {
                ...GridStyles.setRowCol(1, 1),
                fontSize: 60,
                lineHeight: 1.03,
                fontWeight: "bold",
                textAlign: "center",
                ...MediaQuery.mobile({
                    fontSize: 46,
                    lineHeight: 1.09
                })
            },
            button: {
                ...GridStyles.setRowCol(3, 1),
                margin: "0 auto"
            },
            available: {
                ...GridStyles.setRowCol(5, 1),
                fontWeight: "bold",
                fontSize: 13,
                lineHeight: 1.85,
                textAlign: "center",
                ...MediaQuery.mobile({
                    fontSize: 15,
                    lineHeight: 1.6
                }),
                "> a": {
                    color: Config.colors.MAIN_TEXT
                }
            },
            image: {
                ...GridStyles.setRowCol(7, 1),
                maxWidth: 524,
                width: "100%",
                height: "auto",
                margin: "0 auto"
            }
        }),
        downloadText = isMobile ? WhatsNewAreaUtils.getDownloadTextMobile() : WhatsNewAreaUtils.getDownloadText();

    return (
        <div className={css(styles.container, extraStyle)}>
            <TextDiv extraStyle={styles.title} text={Config.messages.switching}/>
            <FeedbackButton extraStyle={styles.button}/>
            <TextDiv extraStyle={styles.available} text={downloadText}/>
            <Image extraStyle={styles.image} src={Config.images.SWITCHING}/>
        </div>
    );
};

export default Switching;
